import { Turbo } from '@hotwired/turbo-rails';
Turbo.session.drive = false;

import 'controllers';

import 'channels';
import colorChannel from '../channels/color_channel';

// --- Student PWA: Service Worker + Push Notifications ---

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/student-service-worker.js')
      .then(registration => {
        console.log('Student SW registered:', registration.scope);
        requestPushPermission(registration);
      })
      .catch(error => {
        console.error('Student SW registration failed:', error);
      });
  });
}

function requestPushPermission(registration) {
  // Don't prompt if already denied or if no VAPID key configured
  if (Notification.permission === 'denied') return;

  const vapidKey = document.querySelector('meta[name="vapid-public-key"]')?.content;
  if (!vapidKey) return;

  // If already granted, just ensure subscription exists
  if (Notification.permission === 'granted') {
    subscribeToPush(registration, vapidKey);
    return;
  }

  // Request permission
  Notification.requestPermission().then(permission => {
    if (permission === 'granted') {
      subscribeToPush(registration, vapidKey);
    }
  });
}

function subscribeToPush(registration, vapidPublicKey) {
  const applicationServerKey = urlBase64ToUint8Array(vapidPublicKey);

  registration.pushManager.getSubscription().then(existingSub => {
    if (existingSub) {
      sendSubscriptionToServer(existingSub);
      return;
    }

    registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: applicationServerKey
    }).then(subscription => {
      sendSubscriptionToServer(subscription);
    }).catch(error => {
      console.error('Push subscription failed:', error);
    });
  });
}

function sendSubscriptionToServer(subscription) {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
  const key = subscription.getKey('p256dh');
  const auth = subscription.getKey('auth');

  fetch('/push_subscribe', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken
    },
    body: JSON.stringify({
      subscription: {
        endpoint: subscription.endpoint,
        p256dh: btoa(String.fromCharCode.apply(null, new Uint8Array(key))),
        auth: btoa(String.fromCharCode.apply(null, new Uint8Array(auth)))
      }
    })
  }).catch(error => {
    console.error('Failed to send push subscription to server:', error);
  });
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
